import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EventLoggerService } from '../../../../../providers/event-logger/event-logger-service';

@Component({
  selector: 'app-ask-for-brand-success',
  templateUrl: './ask-for-brand-success.component.html',
  styleUrls: ['./ask-for-brand-success.component.scss']
})
export class AskForBrandSuccessComponent implements OnInit {
  @Input() brandName: string;

  constructor (public modalController: ModalController, private eventLoggerService:EventLoggerService) { }

  ngOnInit () {
    this.eventLoggerService.logScreen('ask-for-brand-success');

    setTimeout(() => this.modalController.dismiss(), 5000);
  }
}
